---
label: Locking
category: core
icon: LockIcon
keywords: [lock, unlock, read-only, protect, prevent edits]
addedInVersion: "0.0.0"
---

# Locking

Lock a sequence, alignment, or collection to prevent accidental changes.

Locking is useful when you've finished editing and want to preserve the current
state — for example, after finalizing annotations on a sequence or curating a
collection for alignment. It gives you confidence that keyboard shortcuts or
drag-and-drop won't modify something you consider done.

Toggle the lock using the lock icon in the viewer toolbar. While locked, editing
actions are disabled. Unlock at any time to resume editing.
